module.exports = __webpack_public_path__ + "img/Strategy-28.3bd7a052.svg";